import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/article/yoybuy-spreadsheet-guide/page";
import ArticleVsKakobuy from "@/pages/article/yoybuy-vs-kakobuy/page";
import ArticleKakobuyAlt from "@/pages/article/kakobuy-alternative/page";
import ArticleSuperbuyVsYoybuy from "@/pages/article/superbuy-vs-yoybuy/page";
import ArticleTaobaoGuide from "@/pages/article/taobao-spreadsheet-guide/page";
import ArticleShippingGuide from "@/pages/article/china-shipping-guide/page";
import ArticleWholesale from "@/pages/article/china-wholesale-guide/page";
import ArticleSafeBuying from "@/pages/article/safe-china-buying/page";
import ArticleBestAgent from "@/pages/article/best-china-agent-2026/page";
import ArticleAvoidScams from "@/pages/article/avoid-china-scams/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/yoybuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/article/yoybuy-vs-kakobuy",
    element: <ArticleVsKakobuy />,
  },
  {
    path: "/article/kakobuy-alternative",
    element: <ArticleKakobuyAlt />,
  },
  {
    path: "/article/superbuy-vs-yoybuy",
    element: <ArticleSuperbuyVsYoybuy />,
  },
  {
    path: "/article/taobao-spreadsheet-guide",
    element: <ArticleTaobaoGuide />,
  },
  {
    path: "/article/china-shipping-guide",
    element: <ArticleShippingGuide />,
  },
  {
    path: "/article/china-wholesale-guide",
    element: <ArticleWholesale />,
  },
  {
    path: "/article/safe-china-buying",
    element: <ArticleSafeBuying />,
  },
  {
    path: "/article/best-china-agent-2026",
    element: <ArticleBestAgent />,
  },
  {
    path: "/article/avoid-china-scams",
    element: <ArticleAvoidScams />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;